import React from 'react';
import GeneralModal from '../../../../../components/UI/modal/GeneralModal';
import {
    useCloseOtpModal, useGetOtpModalAlertState, useGetOtpModalCheckOtpCodeBtnRef, useGetOtpModalInputRefs, useModalOtpData,
    useSetOtpModalAlertState
} from '../../../../../stores/otpModal.store';
import AlertUser from '../../../../../components/Alerts/AlertUser';
import PreOtpForm from './PreOtpForm';
import OtpFormButtons from './OtpFormButtons';
import useTags from '../../../../../hooks/useTags';
import otpModalLang from '../../../../../data/lang/homePage/otpModal.lang';
import OtpForm from './OtpForm';


const OtpModal = () => {

    const { isOtpModalOpen, portalAction } = useModalOtpData();
    const refs = useGetOtpModalInputRefs();
    const otpBtnRef = useGetOtpModalCheckOtpCodeBtnRef();
    const setOtpModalAlertState = useSetOtpModalAlertState();

    const closeAlert = () => setOtpModalAlertState({
        alertColor: '', message: '', alertStatus: 'noAlert'
    });
    const closeOtpModal = useCloseOtpModal();

    const alertState = useGetOtpModalAlertState();

    const isLoading = alertState.alertStatus === 'loading';

    const generateTag = useTags();
    const modalTitleTag = generateTag(otpModalLang, 'modal-title');
    const modalSubTitleTag = generateTag(otpModalLang, `actions.${portalAction}.modal-sub-title`);


    return (
        <GeneralModal
            show={isOtpModalOpen}
            closingFunc={closeOtpModal}
            title={modalTitleTag}
            modalSize='S'
            loading={isLoading}
            alertUser={<AlertUser state={alertState} onClose={closeAlert} />}
            body={(
                <div className='container p-2'>
                    <p className="fs-4 text-decoration-underline">{modalSubTitleTag}</p>
                    <PreOtpForm />
                    <OtpForm onOtpCodeChange={onOtpCodeChange} />
                </div>
            )}
            footer={<OtpFormButtons />}
        />
    );

    function onOtpCodeChange(e: React.ChangeEvent<HTMLInputElement>, index: number) {

        const value = e.target.value;

        console.log('OTP Input Change:', { value, index });

        if (refs.length <= index) {

            console.warn(`Index ${index} is out of bounds for refs array.`);
            return;
        }

        if (!/^\d*$/.test(value) || !refs[index].current) {

            console.log('Non-numeric input detected, ignoring:', value);

            console.log('ref: ', refs[index].current);
            if (refs[index].current) {
                refs[index].current.value = '';
            }

            return;
        }

        if (index < refs.length - 1 && value) {
            refs[index + 1].current?.focus();
            return;
        } else if (otpBtnRef?.current) {
            otpBtnRef.current.focus();
        }
    }
}

export default OtpModal;